import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "gatsby";
import {
  Container,
  Navbar,
  Nav,
  NavItem,
  NavLink,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button
} from "reactstrap";

import * as actions from "../../state/actions/accessibility";
import { addresses } from "../../utils/variables";
import logo from "../../img/logo-roubaix-blanc.svg";
// import iconPeriscope from "../../img/icons/picto-periscope.svg";
import iconYoutube from "../../img/icons/picto-youtube.svg";
import iconPinterest from "../../img/icons/picto-pinterest.svg";
import iconTiktok from "../../img/icons/picto-tiktok.svg";
// import iconFlickr from "../../img/icons/picto-flickr.svg";
import iconSnapchat from "../../img/icons/picto-snapchat.svg";
import iconLinkedin from "../../img/icons/linked-in.svg";
import iconThreads from "../../img/icons/picto-threads.svg";

import LanguageContext from "./../../state/context/LanguageContext";
import i18n from "./../../i18n/i18n.json";

const defaultState = {
  dropdownSitesOpen: false,
  dropdownSocialOpen: false,
  dropdownAccessibilityOpen: false,
  dropdownLangOpen: false
};

class HeaderTop extends Component {
  constructor(props) {
    super(props);

    this.state = { ...defaultState };
    this.handleSitesMenuKeydown = this.handleSitesMenuKeydown.bind(this);
    this.handleSocialMenuKeydown = this.handleSocialMenuKeydown.bind(this);
    this.handleLangMenuKeydown = this.handleLangMenuKeydown.bind(this);
  }

  getSitesMenuEl() {
    if (!this.state.dropdownSitesOpen) return null;
    return document.querySelector('.nav-sites-dropdown');
  }

  getSocialMenuEl() {
    if (!this.state.dropdownSocialOpen) return null;
    return document.querySelector('.nav-social-dropdown');
  }

  getLangMenuEl() {
    if (!this.state.dropdownLangOpen) return null;
    return document.querySelector('.navbar-lang-dropdown');
  }

  componentDidUpdate(prevProps, prevState) {
    const { dropdownSitesOpen, dropdownSocialOpen, dropdownLangOpen } = this.state;

    if (dropdownSitesOpen && !prevState.dropdownSitesOpen) {
      document.addEventListener('keydown', this.handleSitesMenuKeydown);
      this.focusFirstSitesLink();
    } else if (!dropdownSitesOpen && prevState.dropdownSitesOpen) {
      document.removeEventListener('keydown', this.handleSitesMenuKeydown);
    }

    if (dropdownSocialOpen && !prevState.dropdownSocialOpen) {
      document.addEventListener('keydown', this.handleSocialMenuKeydown);
      this.focusFirstSocialLink();
    } else if (!dropdownSocialOpen && prevState.dropdownSocialOpen) {
      document.removeEventListener('keydown', this.handleSocialMenuKeydown);
    }

    if (dropdownLangOpen && !prevState.dropdownLangOpen) {
      document.addEventListener('keydown', this.handleLangMenuKeydown);
      this.focusFirstLangLink();
    } else if (!dropdownLangOpen && prevState.dropdownLangOpen) {
      document.removeEventListener('keydown', this.handleLangMenuKeydown);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleSitesMenuKeydown);
    document.removeEventListener('keydown', this.handleSocialMenuKeydown);
    document.removeEventListener('keydown', this.handleLangMenuKeydown);
  }

  getSitesFocusables() {
    const menu = this.getSitesMenuEl();
    if (!menu) return [];
    return Array.from(
      menu.querySelectorAll('a[href], button:not([disabled])')
    ).filter(el => el.offsetParent !== null && !el.hasAttribute('disabled'));
  }

  focusFirstSitesLink() {
    // Délai pour laisser le menu (Popper) s'afficher avant de placer le focus
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const focusables = this.getSitesFocusables();
        if (focusables.length > 0) focusables[0].focus();
      });
    });
  }

  handleSitesMenuKeydown(e) {
    if (!this.state.dropdownSitesOpen) return;

    const menu = this.getSitesMenuEl();
    if (!menu || !menu.contains(document.activeElement)) {
      if (e.key === 'Escape') {
        this.toggleSites();
        const toggle = document.getElementById('nav-sites-toggle');
        if (toggle) toggle.focus();
      }
      return;
    }

    if (e.key === 'Escape') {
      e.preventDefault();
      this.toggleSites();
      const toggle = document.getElementById('nav-sites-toggle');
      if (toggle) toggle.focus();
      return;
    }

    if (e.key !== 'Tab') return;

    const focusables = this.getSitesFocusables();
    if (focusables.length === 0) return;

    // Toujours garder le focus dans le menu : on gère Tab/Shift+Tab nous-mêmes
    // pour éviter que le menu se ferme quand le focus sort (comportement Reactstrap).
    e.preventDefault();

    const current = document.activeElement;
    const index = focusables.indexOf(current);
    let nextIndex;

    if (e.shiftKey) {
      nextIndex = index <= 0 ? focusables.length - 1 : index - 1;
    } else {
      nextIndex = index >= focusables.length - 1 || index === -1 ? 0 : index + 1;
    }

    focusables[nextIndex].focus();
  }

  getSocialFocusables() {
    const menu = this.getSocialMenuEl();
    if (!menu) return [];
    return Array.from(
      menu.querySelectorAll('a[href], button:not([disabled])')
    ).filter(el => el.offsetParent !== null && !el.hasAttribute('disabled'));
  }

  focusFirstSocialLink() {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const focusables = this.getSocialFocusables();
        if (focusables.length > 0) focusables[0].focus();
      });
    });
  }

  handleSocialMenuKeydown(e) {
    if (!this.state.dropdownSocialOpen) return;

    const menu = this.getSocialMenuEl();
    if (!menu || !menu.contains(document.activeElement)) {
      if (e.key === 'Escape') {
        this.toggleSocial();
        const toggle = document.getElementById('nav-social-toggle');
        if (toggle) toggle.focus();
      }
      return;
    }

    if (e.key === 'Escape') {
      e.preventDefault();
      this.toggleSocial();
      const toggle = document.getElementById('nav-social-toggle');
      if (toggle) toggle.focus();
      return;
    }

    if (e.key !== 'Tab') return;

    const focusables = this.getSocialFocusables();
    if (focusables.length === 0) return;

    e.preventDefault();
    const current = document.activeElement;
    const index = focusables.indexOf(current);
    const nextIndex = e.shiftKey
      ? (index <= 0 ? focusables.length - 1 : index - 1)
      : (index >= focusables.length - 1 || index === -1 ? 0 : index + 1);
    focusables[nextIndex].focus();
  }

  getLangFocusables() {
    const menu = this.getLangMenuEl();
    if (!menu) return [];
    return Array.from(
      menu.querySelectorAll('a[href], button:not([disabled])')
    ).filter(el => el.offsetParent !== null && !el.hasAttribute('disabled'));
  }

  focusFirstLangLink() {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const focusables = this.getLangFocusables();
        if (focusables.length > 0) focusables[0].focus();
      });
    });
  }

  handleLangMenuKeydown(e) {
    if (!this.state.dropdownLangOpen) return;

    const menu = this.getLangMenuEl();
    if (!menu || !menu.contains(document.activeElement)) {
      if (e.key === 'Escape') {
        this.toggleLang();
        const toggle = document.getElementById('nav-lang-toggle');
        if (toggle) toggle.focus();
      }
      return;
    }

    if (e.key === 'Escape') {
      e.preventDefault();
      this.toggleLang();
      const toggle = document.getElementById('nav-lang-toggle');
      if (toggle) toggle.focus();
      return;
    }

    if (e.key !== 'Tab') return;

    const focusables = this.getLangFocusables();
    if (focusables.length === 0) return;

    e.preventDefault();
    const current = document.activeElement;
    const index = focusables.indexOf(current);
    const nextIndex = e.shiftKey
      ? (index <= 0 ? focusables.length - 1 : index - 1)
      : (index >= focusables.length - 1 || index === -1 ? 0 : index + 1);
    focusables[nextIndex].focus();
  }

  toggleSites = () => {
    this.setState({
      ...defaultState,
      dropdownSitesOpen: !this.state.dropdownSitesOpen
    });
  }
  toggleSocial = () => {
    this.setState({
      ...defaultState,
      dropdownSocialOpen: !this.state.dropdownSocialOpen
    });
  }
  toggleAccessibility = () => {
    this.setState({
      ...defaultState,
      dropdownAccessibilityOpen: !this.state.dropdownAccessibilityOpen
    });
  }
  toggleLang = () => {
    this.setState({
      ...defaultState,
      dropdownLangOpen: !this.state.dropdownLangOpen
    });
  }

  toggleContrast = () => {
    this.props.toggleContrast();
  }
  toggleFontSize = () => {
    this.props.toggleFontSize();
  }
  toggleDyslexia = () => {
    this.props.toggleDyslexia();
  }

  render() {
    return (
      <LanguageContext.Consumer>
        {({ language, translation }) => {
          const languageShortName =
            language &&
              Object.keys(i18n) &&
              Object.keys(i18n).includes(language)
              ? i18n[language].shortName
              : "Fr";
          const homeUrl = language === "fr" ? "/" : `/${language}`;
          return (
            <Navbar
              color="dark"
              expand="md"
              className="header-top py-3 py-lg-1"
              id="pagetop"
            >
              <Container>
                <Link 
                  to={homeUrl} 
                  className="navbar-brand pr-4"
                  aria-label="Retour à l'accueil du site de la Ville de Roubaix"
                  title="Retour à l'accueil du site de la Ville de Roubaix"
                >
                  <img src={logo} alt="Logo Ville de Roubaix" />
                </Link>
                <Nav className="mr-auto nav-sites" navbar>
                  <Dropdown
                    nav
                    isOpen={this.state.dropdownSitesOpen}
                    toggle={this.toggleSites}
                  >
                    <DropdownToggle nav caret tag="button" type="button" id="nav-sites-toggle" aria-haspopup="true" aria-expanded={this.state.dropdownSitesOpen}>
                      {translation.allsites}
                    </DropdownToggle>
                    <DropdownMenu className="nav-sites-dropdown" left="auto" role="menu">
                      <DropdownItem tag="div">
                        <NavLink
                          target="_blank"
                          rel="noopener noreferrer"
                          className="nav-sites-link nav-sites-xxl"
                          href={addresses.roubaixxl}
                          aria-label="RoubaiXXL (s'ouvre dans un nouvel onglet)"
                        >
                          {translation.roubaixxl}
                        </NavLink>
                      </DropdownItem>
                      <DropdownItem tag="div">
                        <NavLink
                          target="_blank"
                          rel="noopener noreferrer"
                          className="nav-sites-link nav-sites-demarches"
                          href={addresses.roubaixdemarche}
                          aria-label={`${translation.demarche} (s'ouvre dans un nouvel onglet)`}
                        >
                          {translation.demarche}
                        </NavLink>
                      </DropdownItem>
                      <DropdownItem tag="div">
                        <NavLink
                          className="nav-sites-link nav-sites-viva"
                          href={addresses.roubaixviva}
                        >
                          {translation.vivacite}
                        </NavLink>
                      </DropdownItem>
                      <DropdownItem tag="div">
                        <NavLink
                          target="_blank"
                          rel="noopener noreferrer"
                          className="nav-sites-link nav-sites-lafabs"
                          href={addresses.lafabrique}
                          aria-label="La Fabrique (s'ouvre dans un nouvel onglet)"
                        >
                          {translation.lafabrique}
                        </NavLink>
                      </DropdownItem>
                      <DropdownItem tag="div">
                        <NavLink
                          target="_blank"
                          rel="noopener noreferrer"
                          className="nav-sites-link nav-sites-carte"
                          href={addresses.roubaixcarte}
                          aria-label={`${translation.carte} (s'ouvre dans un nouvel onglet)`}
                        >
                          {translation.carte}
                        </NavLink>
                      </DropdownItem>
                      <DropdownItem tag="div">
                        <Link
                          className="nav-sites-btn nav-link mb-3"
                          to="liens"
                        >
                          {translation.alllinks}
                        </Link>
                      </DropdownItem>
                      <DropdownItem tag="div">
                        <NavLink
                          target="_blank"
                          rel="noopener noreferrer"
                          className="nav-sites-btn nav-sites-btn-alt"
                          href={addresses.roubaixemploi}
                          aria-label={`${translation.jobs} (s'ouvre dans un nouvel onglet)`}
                        >
                          {translation.jobs}
                        </NavLink>
                      </DropdownItem>
                      <DropdownItem tag="div">
                        <NavLink
                          target="_blank"
                          rel="noopener noreferrer"
                          className="nav-sites-btn"
                          href={addresses.roubaixfournisseur}
                          aria-label={`${translation.providers} (s'ouvre dans un nouvel onglet)`}
                        >
                          {translation.providers}
                        </NavLink>
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </Nav>
                <div className="d-flex ml-auto">
                  <Nav navbar className="nav-social">
                    <NavItem className="d-flex align-items-center">
                      <NavLink
                        target="_blank"
                        rel="noopener noreferrer"
                        href={addresses.facebook}
                        className="icon-link d-block text-center text-dark rounded-circle mr-1 p-0"
                        aria-label="Page Facebook de la mairie de Roubaix (s'ouvre dans un nouvel onglet)"
                      >
                        <i className="icon-facebook" />
                      </NavLink>
                    </NavItem>
                    <NavItem className="d-flex align-items-center">
                      <NavLink
                        target="_blank"
                        rel="noopener noreferrer"
                        href={addresses.twitter}
                        className="icon-link d-block text-center text-dark rounded-circle mr-1 p-0"
                        aria-label="Page Twitter de la mairie de Roubaix (s'ouvre dans un nouvel onglet)"
                      >
                        <i className="icon-twitter" />
                      </NavLink>
                    </NavItem>
                    <NavItem className="d-flex align-items-center">
                      <NavLink
                        target="_blank"
                        rel="noopener noreferrer"
                        href={addresses.instagram}
                        className="icon-link d-block text-center text-dark rounded-circle mr-1 p-0"
                        aria-label="Page Instagram de la mairie de Roubaix (s'ouvre dans un nouvel onglet)"
                      >
                        <i className="icon-instagram" />
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Nav navbar>
                    <Dropdown
                      nav
                      className="nav-more pr-3 mr-2"
                      isOpen={this.state.dropdownSocialOpen}
                      toggle={this.toggleSocial}
                    >
                      <DropdownToggle nav caret tag="button" type="button" id="nav-social-toggle" aria-haspopup="true" aria-expanded={this.state.dropdownSocialOpen} title="Plus de réseaux sociaux">
                        {translation.more}
                      </DropdownToggle>
                      <DropdownMenu className="nav-social-dropdown" role="menu">
                        <DropdownItem tag="div">
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={addresses.youtube}
                            aria-label="Chaîne YouTube de la mairie de Roubaix (s'ouvre dans un nouvel onglet)"
                          >
                            <img src={iconYoutube} alt="" />
                          </a>
                        </DropdownItem>
                        <DropdownItem tag="div">
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={addresses.pinterest}
                            aria-label="Page Pinterest de la mairie de Roubaix (s'ouvre dans un nouvel onglet)"
                          >
                            <img src={iconPinterest} alt="" />
                          </a>
                        </DropdownItem>
                        <DropdownItem tag="div">
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={addresses.tiktok}
                            aria-label="Page TikTok de la mairie de Roubaix (s'ouvre dans un nouvel onglet)"
                          >
                            <img src={iconTiktok} alt="" />
                          </a>
                        </DropdownItem>
                        <DropdownItem tag="div">
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={addresses.snapchat}
                            aria-label="Page Snapchat de la mairie de Roubaix (s'ouvre dans un nouvel onglet)"
                          >
                            <img src={iconSnapchat} alt="" />
                          </a>
                        </DropdownItem>
                        <DropdownItem tag="div">
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={addresses.linkedin}
                            aria-label="Page LinkedIn de la mairie de Roubaix (s'ouvre dans un nouvel onglet)"
                          >
                            <img src={iconLinkedin} alt="" />
                          </a>
                        </DropdownItem>
                        <DropdownItem tag="div">
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={addresses.threads}
                            aria-label="Page Threads de la mairie de Roubaix (s'ouvre dans un nouvel onglet)"
                          >
                            <img src={iconThreads} alt="" />
                          </a>
                        </DropdownItem>
                        {/* <DropdownItem tag="div">
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={addresses.periscope}
                          >
                            <img src={iconPeriscope} alt="" />
                          </a>
                        </DropdownItem>
                        <DropdownItem tag="div">
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={addresses.flickr}
                          >
                            <img src={iconFlickr} alt="" />
                          </a>
                        </DropdownItem> */}
                      </DropdownMenu>
                    </Dropdown>
                  </Nav>

                  {/* <Nav navbar className="navbar-accessibility">
                    <Dropdown
                      nav
                      className="nav-more pr-3 mr-2"
                      isOpen={this.state.dropdownAccessibilityOpen}
                      toggle={this.toggleAccessibility}
                    >
                      <DropdownToggle nav caret>
                        <i className="icon-accessibility" />{" "}
                        {translation.headerAccessibility}
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem tag="div">
                          <Button color="dark" onClick={this.toggleContrast}>
                            <i className="icon-brightness_medium" />{" "}
                            {translation.contraste}
                          </Button>
                        </DropdownItem>
                        <DropdownItem tag="div">
                          <Button
                            color="link"
                            className="fontx2"
                            onClick={this.toggleFontSize}
                          >
                            <i className="icon-format_size" />{" "}
                            {translation.textsize}
                          </Button>
                        </DropdownItem>
                        <DropdownItem tag="div">
                          <Button
                            color="link"
                            className="open-dyslexic"
                            onClick={this.toggleDyslexia}
                          >
                            {translation.dyslexie}
                          </Button>
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </Nav> */}

                  <Nav navbar className="navbar-lang">
                    <Dropdown
                      nav
                      isOpen={this.state.dropdownLangOpen}
                      toggle={this.toggleLang}
                    >
                      <DropdownToggle nav caret tag="button" type="button" id="nav-lang-toggle" aria-haspopup="true" aria-expanded={this.state.dropdownLangOpen}>
                        {languageShortName}
                      </DropdownToggle>
                      <DropdownMenu right className="navbar-lang-dropdown" role="menu">
                        {Object.keys(i18n).map((l, key) => {
                          const languageName = i18n[l].name || i18n[l].shortName
                          const isCurrentLanguage = l === language
                          const linkLabel = isCurrentLanguage 
                            ? `Afficher le site en ${languageName} (langue actuelle)`
                            : `Changer la langue en ${languageName}`
                          return (
                            <DropdownItem tag="div" key={key}>
                              <NavLink 
                                href={i18n[l].home} 
                                className="btn-link"
                                aria-label={linkLabel}
                                title={linkLabel}
                              >
                                {languageName}
                              </NavLink>
                            </DropdownItem>
                          )
                        })}
                      </DropdownMenu>
                    </Dropdown>
                  </Nav>
                </div>
              </Container>
            </Navbar>
          );
        }}
      </LanguageContext.Consumer>
    );
  }
}

export default connect(
  null,
  actions
)(HeaderTop);
